import Vue from 'vue'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import App from './App.vue'
import router from './router'
import { initApiConfig, setApiServer } from './config/api'
import { bootstrapApis } from './config/bootstrap'
import { FIXED_API_SERVER } from './config/demoProject'
import './styles/app.scss'

initApiConfig()
setApiServer(FIXED_API_SERVER)
bootstrapApis()

Vue.use(ViewUI)
Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  console.error('[P1_VP12]', info, err)
  const el = document.getElementById('app')
  if (el && !el.dataset.errorShown) {
    el.dataset.errorShown = '1'
    el.innerHTML = `<pre style="color:#f07178;padding:24px;white-space:pre-wrap;font:13px/1.4 monospace">P1_VP12 boot error:\n${err && err.stack ? err.stack : err}</pre>`
  }
}

window.addEventListener('unhandledrejection', (ev) => {
  console.error('[P1_VP12] unhandledrejection', ev.reason)
})

try {
  new Vue({
    router,
    render: (h) => h(App)
  }).$mount('#app')
} catch (err) {
  console.error('[P1_VP12] mount failed', err)
  const el = document.getElementById('app')
  if (el) {
    el.innerHTML = `<pre style="color:#f07178;padding:24px;white-space:pre-wrap;font:13px/1.4 monospace">P1_VP12 mount failed:\n${err && err.stack ? err.stack : err}</pre>`
  }
}
